import Map from 'ol/Map';
import Draw, { DrawEvent } from 'ol/interaction/Draw';
import { Modify, Snap } from 'ol/interaction';
import VectorSource from 'ol/source/Vector';
import { DrawLayer } from '../ol/drawing-layer';
import { DrawingManagerOption } from '@app/new-ui/location/location.component';
import GeoJSON from 'ol/format/GeoJSON';
import { geojson } from '@lib/geojson';

export class MapInteractionDraw {
    private drawLayer: DrawLayer;

    constructor() {
        this.drawLayer = new DrawLayer();
    }

    public addDrawInteraction(map: Map, drawType: DrawingManagerOption): Draw {
        const vectorSource = this.drawLayer.initializeDrawingLayer(map);

        const drawInteraction = new Draw({
            source: vectorSource,
            type: drawType,
        });
        map.addInteraction(drawInteraction);
        return drawInteraction;
    }

	public async addDrawInteractionAsync(
        map: Map,
        drawType: DrawingManagerOption
    ): Promise<geojson.Geometry | null> {
        const vectorSource = this.drawLayer.initializeDrawingLayer(map);

        const drawInteraction = new Draw({
            source: vectorSource,
            type: drawType,
        });

        map.addInteraction(drawInteraction);

        return new Promise((resolve, reject) => {
            const onDrawEnd = (event:DrawEvent) => {
                const geometry = event.feature?.getGeometry();
                if (geometry) {
                    const geoJson = new GeoJSON().writeGeometryObject(geometry);
                    resolve(geoJson as geojson.Geometry);
                } else {
                    reject(new Error('No geometry was drawn.'));
                }
                map.removeInteraction(drawInteraction);
                drawInteraction.un('drawend', onDrawEnd);
            };

            drawInteraction.on('drawend', onDrawEnd);

            const timeout = setTimeout(() => {
                reject(new Error('Drawing timed out.'));
                map.removeInteraction(drawInteraction);
                drawInteraction.un('drawend', onDrawEnd);
            }, 60000);

            drawInteraction.on('drawend', () => clearTimeout(timeout));
        });
    }
    
    public async removeDrawLayer(map: Map) {
        const layer = this.drawLayer.getLayer();
    
        if (layer) {
            map.removeLayer(layer);
        } else {
            console.warn('Layer not found in map.');
        }
    }

    public addModifyAndSnapInteractions(map: Map): void {
        const drawingLayer = this.drawLayer.getLayer();
        if (!drawingLayer) {
            console.error('Drawing layer not initialized.');
            return;
        }

        const vectorSource = drawingLayer.getSource() as VectorSource;
        const modifyInteraction = new Modify({ source: vectorSource });
        const snapInteraction = new Snap({ source: vectorSource });

        map.addInteraction(modifyInteraction);
        map.addInteraction(snapInteraction);
    }

    public removeInteraction(map: Map, interaction: Draw | Modify | Snap): void {
        map.removeInteraction(interaction);
    }
}
